module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-medical-fill-fb6957f3.svg";